export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT';
export const START_WORKLOG_NOW_SUCCESS = 'START_WORKLOG_NOW_SUCCESS_EVENT';
export const STOP_WORKLOG_NOW_SUCCESS = 'STOP_WORKLOG_NOW_SUCCESS_EVENT';
export const SET_EVENT_FORCE_MODE = 'SET_EVENT_FORCE_MODE';
